import React, { Fragment } from 'react';
import MultiSelectInput from './../../se/components/inputs/MultiSelectInput';

type Option = { value: string, label: 'Staff Schedule v1' | 'Staff Schedule v2' | 'OR Schedule v1' | 'OR Schedule v2' };

const schedulePdfsOptions = [
  {
    label: 'Staff Schedule v1',
    value: 'Staff Schedule v1',
  },
  {
    label: 'Staff Schedule v2',
    value: 'Staff Schedule v2',
  },
  {
    label: 'OR Schedule v1',
    value: 'OR Schedule v1',
  },
  {
    label: 'OR Schedule v2',
    value: 'OR Schedule v2',
  },
]

const SchedulePdfsMultipleSelectInput = ({ value, onChange } : { value: Option[], onChange: (value: Option[]) => void }) => {
  return (
    <Fragment>
      <MultiSelectInput
        name={`SchedulePDFs`}
        options={schedulePdfsOptions}
        onChange={onChange}
        value={value}
        loading={false}
        disabled={false}
      />
    </Fragment>
  );
};

export default SchedulePdfsMultipleSelectInput;
